module.exports = __webpack_public_path__ + "static/media/img-glovo.d598ed74.svg";